<template>
  <v-app>
    <v-container fluid>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          elevation="0"
          @click="onClickCard()"
        >
          閉じる
        </v-btn>
      </v-card-actions>
      <v-row dense>
        <v-col
          cols="12"
          lg="4"
          md="4"
          sm="4"
          xl="3"
        >
          <v-btn
            color="secondary"
            elevation="0"
            height="60"
            max-height="60"
            style="border-radius: 8px;font-size: 17px;font-weight: bold"
            width="100%"
            @click="showEditDialog"
          >
            <v-img
              class="mr-3"
              contain
              max-height="22px"
              max-width="22px"
              src="../assets/file_w.png"
            />
            　 定型文の追加
            <v-spacer />
            <v-img
              contain
              max-height="22px"
              max-width="22px"
              src="../assets/plus_w.png"
            />
          </v-btn>
        </v-col>
        <v-col
          v-for="(item) in templateList"
          :key="item.id"
          cols="12"
          lg="4"
          md="4"
          sm="4"
          xl="3"
        >
          <v-card
            class="mx-auto "
            flat
            height="180"
            max-height="200"
            style="border-radius: 8px"
            @click="onClickCard(item)"
            @keydown.enter="onClickCard(item)"
          >
            <v-card-text>
              <v-clamp
                :max-lines="4"
                autoresize
                class="pa-0 ma-0"
                style="font-size: 12px;height: 90px;"
              >
                {{ item.label }}
              </v-clamp>
            </v-card-text>

            <v-card-actions class="pa-0 ma-0">
              <v-list-item class="grow">
                <v-row
                  align="center"
                  justify="end"
                >
                  <v-btn
                    class="pl-4 pr-4"
                    color="secondary"
                    elevation="0"
                    small
                    style="color:#FFFFFF;"
                    tile
                    @click.stop="showEditDialog(item)"
                  >
                    編集
                  </v-btn>
                  <!--<span class="subheading mr-2">256</span>-->
                  <!--<span class="mr-1">·</span>-->
                  <v-btn
                    icon
                    @click.stop="showDeleteDialog(item)"
                  >
                    <DeleteIcon style="width: 20px;height: 25px;" />
                  </v-btn>
                  <!--<span class="subheading">45</span>-->
                </v-row>
              </v-list-item>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="addDialog"
      max-width="790"
    >
      <v-card class="mx-auto">
        <v-card-title>
          {{ editItem.id ? "定型文編集" : "新しい定型文の追加" }}
        </v-card-title>

        <v-col>
          <v-textarea
            v-model="editText"
            auto-grow
            color="text"
            filled
          />
        </v-col>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="addDialog=false"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="save"
              >
                保存
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text v-if="deleteItemData!=null">
          指定の定型文を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import DeleteIcon from "@/component/svg/DeleteIcon";
import VClamp from 'vue-clamp'
import clonedeep from 'lodash.clonedeep'
export default {
  name: 'Template',
  components: {DeleteIcon, VClamp},
  computed: {
    ...mapState({
      templateList: state => state.TemplateTextListModule.TemplateTextList,
    }),
  },
  data() {
    return {
      addDialog: false,
      deleteDialog: false,
      deleteItemData: null,
      editItem: {},
      editText: ""
    }
  },
  mounted() {
    this.$store.dispatch("TemplateTextListModule/getValue")
  },
  methods: {
    showDeleteDialog(item) {
      this.deleteItemData = item;
      this.deleteDialog = true;
    },
    showEditDialog(item = null) {
      this.editItem = item == null ? {label: ""} : item
      this.editText = item == null ? "" : item.label
      this.addDialog = true
    },
    save() {
      let newData = clonedeep(this.editItem)
      newData.label = this.editText

      this.$store.dispatch("TemplateTextListModule/updateParams", {newData: newData}).then(
          value => {
            this.addDialog = false
          }
      ).catch(reason => {
        alert("データ更新に失敗しました。再度お試しください")
      })
    },
    deleteItem(deleteItemData) {
      this.$store.dispatch("TemplateTextListModule/delete", {
        item: deleteItemData,
      }).catch(reason => {
        alert("削除中にエラーが発生しました")
      });

      this.deleteDialog = false;
    },
    onClickCard(item) {
      this.$emit('onClickText', item);
    }
  }
}
</script>

<style>

</style>
